













































































































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { DailyReportServiceExt } from '../../biz/DailyReportServiceExt';
import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import BasicStrengthPanel from './BasicStrengthPanel.vue';
import { dayjs, DT_FORMAT_JA, DT_FORMAT_JA_WO_Y } from '../../../src_server/common/momentExtends';
import { subjectsOptions } from '../../../src_server/entity/master/subjectsData';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';
import FileAttach from '../fileattach/FileAttach.vue';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import CommentAndFilePanel from './CommentAndFilePanel.vue';
import FileAddDialog from './FileAddDialog.vue';
import { FileHandler, FileAndUrl } from '../fileattach/FileHandler';
import EvaluationSection from './section/EvaluationSection.vue';

@Component({
  components: {
    BasicStrengthPanel,
    SimpleSelect,
    FileAttach,
    CommentAndFilePanel,
    FileAddDialog,
    EvaluationSection,
  },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA);
    },
    dateFormatWoY: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA_WO_Y);
    },
  },
})
export default class ReportPage extends Vue {
  private dto: ReportDTO = new ReportDTO();
  private class_id = 0;

  @Prop({ default: false })
  private isReadOnly!: boolean;

  @Prop({ required: true, default: '' })
  private user_type!: string;

  private isReEditMode = false;

  private is_another_editing = false;
  private editing_user = '';
  private editingDate = new Date();

  // 添付ファイル
  private attachedFiles: FileAndUrl[] = [];

  get isStudent() {
    return this.user_type === 'stu';
  }

  get subjects() {
    return subjectsOptions;
  }

  /**
   * 空っぽか、自分のIDだったら自分が編集中
   */
  get isEditingMe() {
    return !this.editing_user || this.editing_user === Session.getSessionUserId();
  }

  get isTeacherMode() {
    const sessionUserId = Session.getSessionUserId();
    return this.dto.lessons.teacher_user_id === sessionUserId;
  }

  get isEditMode() {
    // 読み取り専用だったら、モードを切り替えない
    if (this.isReadOnly) {
      return false;
    }
    // 実施済の状態ではなくかつ編集ボタンを押した場合にtrue
    return this.dto.lessons.reservation_state !== LessonStates.ALREADY || this.isReEditMode;
  }

  async evalSend(value: number) {
    this.dto.report.evaluation = value;
  }

  async loadReport() {
    const class_id_param = this.$route.query.class_id as string;
    if (!class_id_param) {
      MessageDialog.systemError('レッスンID', '日報表示時', class_id_param).then();
      return;
    }
    // 引数は文字列になっているので数値化
    this.class_id = parseInt(class_id_param);

    // 日報データを取得
    const biz = new DailyReportServiceExt();
    const resonse = await biz.getReportForInput(this.class_id, Session.getSessionUserId());
    if (resonse.hasError) {
      await MessageDialog.systemError('日報', '日報表示時', resonse.data);
      return;
    }
    this.dto = resonse.data;

    this.is_another_editing = !this.dto.report.locking_dt;
    this.editing_user = this.dto.report.locking_user_id || '';
    this.editingDate = this.dto.report.locking_dt!;

    // 編集モードだったら、一時保存されているデータを取り出す
    if (this.isEditMode) {
      const repBiz = new DailyReportServiceExt();
      const sessionDTO = repBiz.laoadTemp(this.class_id);
      if (sessionDTO) {
        this.dto = sessionDTO;
      }
    }
  }

  async mounted() {
    await this.loadReport();
  }

  save() {
    console.log();
    const biz = new DailyReportServiceExt();
    biz.saveTemporary(this.dto, Session.getSessionBuildingId());
    MessageDialog.alert('下書き保存しました').then();
  }

  /**
   * 基礎力レベルのコールバック
   */
  changeStrength(value: boolean, index: number) {
    this.dto.strength[index].is_done = value;
  }

  /**
   * 日報の最初の送信
   */
  async send() {
    console.log(new Number(this.dto.report.goal_rate));
    if (Number.isNaN(parseInt(`${this.dto.report.goal_rate}`))) {
      await MessageDialog.alert('本日の狙いの達成率は数字で入力してください');
      return;
    }
    if (!this.dto.report.lesson_point) {
      await MessageDialog.alert('本日の流れを入力してください');
      return;
    }
    if (!this.dto.report.lesson_goal) {
      await MessageDialog.alert('本日の狙いを入力してください');
      return;
    }
    if (!this.dto.report.student_state) {
      await MessageDialog.alert('授業の振り返り（良かった点・反省点など）を入力してください');
      return;
    }
    if (!this.dto.report.homework) {
      await MessageDialog.alert('次回までの宿題を入力してください');
      return;
    }

    const isOk = await MessageDialog.confirm('日報を保存し、生徒/保護者に通知を実施します。よろしいですか。');
    if (isOk) {
      // ファイルをアップロードしてパスを取得
      this.dto.uploadFirstFiles = await FileHandler.fileAttachUpload(Session.getSessionUserId(), this.attachedFiles);
      const biz = new DailyReportServiceExt();
      await biz.saveAndSendNotify(this.dto, Session.getSessionBuildingId());
      history.back();
    }
  }

  addFile(file: FileAndUrl) {
    this.attachedFiles.push(file);
  }

  delFile(index: number) {
    console.log('del ', index);
    this.attachedFiles.splice(index);
  }

  reEdit() {
    this.isReEditMode = true;
  }
  openFolder() {
    const link = this.dto.lesson_movie_save_url;
    window.open(link, '_blank');
  }

  /**
   * 記入中の内容を保存
   */
  writeingSave() {
    const biz = new DailyReportServiceExt();
    biz.saveTemp(this.class_id, this.dto);
  }

  async showAddFile() {
    const dialog: FileAddDialog = this.$refs['FileAddDialog'] as FileAddDialog;
    dialog.show(this.dto);
  }
}
